// extracted by mini-css-extract-plugin
export default {"button":"styles__button___ukX0z"};